/** @format */

import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import global from "../../global-variables";
import Header from "../layout/header";
import { Link } from "react-router-dom";
import $ from "jquery";
import WOW from "wowjs";
import { FaAngleLeft } from "react-icons/fa";
import { Container, Row, Col } from "reactstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import FsLightbox from "fslightbox-react";
import { Button } from "react-bootstrap";
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';

import Metatag from "../../hooks/Metatag";
import axios from "axios";
import globalVariables from "../../global-variables";
import { GetResearchGalleryList } from "../../api/research-gallery-function";
import FacultyList from "../../Components/FacultyList";

export default function GESHProjectdestails() {

  const { res_pagename, rtype_pagename } = useParams();
  const qs_res_pagename = res_pagename;
  const qs_rtype_pagename = rtype_pagename;

  const [researchDetails, setResearchDetails] = useState({
    researchList: [],
    researchGalleryList: []
  });

  //get research list
  useEffect(() => {
    let _obj = new Object();
    _obj.res_pagename = qs_res_pagename;
    _obj.rtype_pagename = qs_rtype_pagename;
    _obj.res_status = 1;

    axios
      .post(
        globalVariables.variables.strApiUrl + "/researchApi/getresearchList",
        _obj
      )
      .then((response_researchList) => {
        if (response_researchList.data === "error") {
          navigate("/error-page");
        } else {
          setResearchDetails((prev) => ({ ...prev, researchList: response_researchList.data[0] }));
        }
      });

  }, [qs_res_pagename]);

  //get research gallery
  useEffect(() => {

    let _objResearchGallery = new Object();
    _objResearchGallery.res_gallery_status = 1;
    _objResearchGallery.res_gallery_res_id = researchDetails.researchList[0]?.res_id;

    //Get research gallery List
    axios.post(globalVariables.variables.strApiUrl + '/researchGalleryApi/getResearchGalleryList', _objResearchGallery)
      .then((response_list) => {
        if (response_list.data === 'error') {
          navigate('/error-page')
        }
        else {
          // pass the result in the success function of the respective page
          setResearchDetails((prev) => ({ ...prev, researchGalleryList: response_list.data[0] }))
        }
      });

  }, [researchDetails.researchList[0]?.res_id])

  const [toggler, setToggler] = useState(true);
  const [show, setShow] = useState(false);
  const [index, setIndex] = useState(0);

  const [key, setKey] = useState('Day 1');

  const [research_gallery_toggler, setResearchGalleryToggler] = useState(false);
  const [research_gallery, setResearchGallery] = useState([]);
  const [gallery_key, setGalleryKey] = useState("");
  const [gallerySlide, setGallerySlide] = useState("");


  // success function when event gallery is retrived
  const OnGetResearchGallerySuccess = (p_response) => {
    // set the array in the constant
    setResearchGallery(p_response);

    setGalleryKey(Date.now());
    // using time out for the value to get saved in state 
    setTimeout(() => {
      // trigger the link click to display the research gallery popup
      document.getElementById("lnk_trigger_research_gallery_popup_home").click();
    }, 200);

  }

  // function to invoke photo gallery
  const InvokePhotoGallery = (e, p_event_id, index) => {

    e.preventDefault();
    setGallerySlide(index)
    // Make an object for getting event gallery
    let _objEventGallery = new Object();
    _objEventGallery.res_gallery_status = 1;
    _objEventGallery.res_gallery_res_id = p_event_id;

    // call the function to get the event gallery
    GetResearchGalleryList(_objEventGallery, OnGetResearchGallerySuccess);

  };

  const navigate = useNavigate();

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  useEffect(() => {
    $(window).on("scroll", function () {
      $(".navbar").offset().top > 10
        ? $(".fixed-top").removeClass("bg-header-home")
        : $(".fixed-top").removeClass("bg-header-home");
    });

    // initiate the wow effect
    new WOW.WOW({
      live: false,
    }).init();
  }, [researchDetails.researchList]);

  const [resDepartmentList, setresDepartmentList] = useState(null)
  const [resFocusAreaList, setresFocusAreaList] = useState(null)
  const [resSdgList, setresSdgList] = useState(null)

  useEffect(() => {
    let _obj = new Object();
    //get department list
    axios.post(globalVariables.variables.strApiUrl + '/researchApi/getonlymappedResearchDepartmentList',_obj)
      .then((response) => {
        setresDepartmentList(response.data[0])
      });

      let _obj2 = new Object();
    //get focus area list
    axios.post(globalVariables.variables.strApiUrl + '/researchApi/getonlymappedResearchFocusAreaList',_obj2)
      .then((response) => {
        setresFocusAreaList(response.data[0])
      });

      let _obj3 = new Object();
    //get sdg list
    axios.post(globalVariables.variables.strApiUrl + '/researchApi/getonlymappedResearchSdgList',_obj3)
      .then((response) => {
        setresSdgList(response.data[0])
      });

  }, [])


  // Create a hash map for department
  const departmentMap = useMemo(() => {

    return resDepartmentList && resDepartmentList.reduce((map, depart) => {

      if (!map[depart.map_res_depart_res_id]) {
        map[depart.map_res_depart_res_id] = [];
      }
      map[depart.map_res_depart_res_id].push(depart);
      return map;
    }, {});
  }, [resDepartmentList])

  // Create a hash map for focus area
  const focusAreaMap = useMemo(() => {

    return resFocusAreaList && resFocusAreaList.reduce((map, focus_area) => {

      if (!map[focus_area.res_focus_ar_res_id]) {
        map[focus_area.res_focus_ar_res_id] = [];
      }
      map[focus_area.res_focus_ar_res_id].push(focus_area);
      return map;
    }, {});
  }, [resFocusAreaList])

  // Create a hash map for sdg
  const sdgMap = useMemo(() => {

    return resSdgList && resSdgList.reduce((map, sdg) => {

      if (!map[sdg.res_sdg_res_id]) {
        map[sdg.res_sdg_res_id] = [];
      }
      map[sdg.res_sdg_res_id].push(sdg);
      return map;
    }, {});
  }, [resSdgList])


  return (
    <>
      <Header></Header>
      <Metatag title={researchDetails.researchList[0]?.res_pagetitle}
        description={researchDetails.researchList[0]?.res_meta_description}
        keywords={researchDetails.researchList[0]?.res_meta_keywords}
      />
      {/* Research Visual Panel */}
      {
        researchDetails.researchList.length > 0 ?
          <>
            <Container fluid className="bg-visual-inside-eve-details p-0" >
              <div className="visual-inside-big">
                <Container>
                  <Row className="g-md-0 rounded-4 justify-content-center align-items-center mt-md-5 mt-4">
                    <Col xs={8} md={6}>
                      <h1 className="fw-light text-white d-inline-block m-0 align-self-center wow fadeInUp">
                        {researchDetails.researchList[0]?.rtype_name}
                      </h1>
                    </Col>
                    <Col xs={4} md={6}>
                      <Button onClick={() => navigate(-1)} className="btn btn-primary rounded-pill Faicon px-3 py-1 ms-auto d-flex align-items-center wow fadeInUp">
                        <FaAngleLeft /> Back
                      </Button>
                    </Col>
                  </Row>
                </Container>
              </div>
            </Container>

            <Container className="event-info pt-4 pt-md-5 pt-xl-0 pb-5">
              <div className="rounded-4 bg-light shadow-sm position-relative overflow-hidden">
                <Row className="p-md-4 p-3 g-3">
                  {/* {
                researchDetails.researchList[0]?.res_img !== null && researchDetails.researchList[0]?.res_img !== "" ? (
                <Col md={8} lg={6} className="ps-lg-4 px-lg-3 pe-md-5">
                  <img src={`${global.variables.strApiUrl}/research-image/${researchDetails.researchList[0]?.res_img}`} alt={researchDetails.researchList[0]?.res_title} title={researchDetails.researchList[0]?.res_title} className="img-fluid rounded-3 bg-white wow fadeInUp" />
                </Col>
                ) :

                <Col md={8} lg={6} className="ps-lg-4 px-lg-3 pe-md-5">
                  <img src={global.variables.strDomainUrl + "images/default-research-banner.png"} alt={researchDetails.researchList[0]?.res_title} title={researchDetails.researchList[0]?.res_title} className="img-fluid rounded-3 bg-white wow fadeInUp" />
                </Col>
              } */}
                  <Col md={12} lg={6} className="d-flex align-items-start flex-column px-lg-4">
                    <h5 className="mb-3 lh-base text-dark wow fadeInUp">
                      {researchDetails.researchList[0]?.res_title}
                    </h5>

                    <ul className="list-group projectslist mb-3 wow fadeInUp">
                      <FacultyList res_id={researchDetails.researchList[0]?.res_id} />

                      {/* {researchDetails.researchList[0]?.res_depart_json !== null && researchDetails.researchList[0]?.res_depart_json !== undefined ? (
                  <li className="list-group-item border-0 px-0 py-1 bg-transparent">
                    <span className="text-black fw-medium">Department(s):</span>
                    {
                      JSON.parse(researchDetails.researchList[0]?.res_depart_json).map((department, i) => (
                        <>
                        <span key={i}>
                          {" "}{department.res_depart_name}
                        </span>
                          {i < JSON.parse(researchDetails.researchList[0]?.res_depart_json).length - 1 && ','}
                        </>
                      ))
                      }              
                  </li>
                  )
                  :
                  null
                  } */}
                      {resDepartmentList !== null ? (
                        <li className="list-group-item border-0 px-0 py-1 bg-transparent">
                          <span className="text-black fw-medium">Department(s):</span>
                          {
                            departmentMap[researchDetails.researchList[0]?.res_id]?.map((department, i) => (
                              <>
                                <span key={i}>
                                  {" "}{department.res_depart_name}
                                </span>
                                {i < departmentMap[researchDetails.researchList[0]?.res_id]?.length - 1 && ','}
                              </>
                            ))
                          }
                        </li>
                      )
                        :
                        null
                      }
                      {/* {researchDetails.researchList[0]?.res_focus_ar_json !== null && researchDetails.researchList[0]?.res_focus_ar_json !== undefined ? (
                  <li className="list-group-item border-0 px-0 py-1 bg-transparent">
                    <span className="text-black fw-medium">Focus Areas:</span>
                    {
                      JSON.parse(researchDetails.researchList[0]?.res_focus_ar_json).map((focusArea, i) => (
                        <>
                        <span key={i}>
                          {" "}{focusArea.focus_ar_name}
                        </span>
                          {i < JSON.parse(researchDetails.researchList[0]?.res_focus_ar_json).length - 1 && ','}
                        </>
                      ))
                      }
                  </li>
                  )
                  :
                  null
                  } */}
                      {resFocusAreaList !== null ? (
                        <li className="list-group-item border-0 px-0 py-1 bg-transparent">
                          <span className="text-black fw-medium">Focus Areas:</span>
                          {
                            focusAreaMap[researchDetails.researchList[0]?.res_id]?.map((focusArea, i) => (
                              <>
                                <span key={i}>
                                  {" "}{focusArea.focus_ar_name}
                                </span>
                                {i < focusAreaMap[researchDetails.researchList[0]?.res_id]?.length - 1 && ','}
                              </>
                            ))
                          }
                        </li>
                      )
                        :
                        null
                      }
                    </ul>
                    {/* {
                  researchDetails.researchList[0]?.res_sdg_json !== null && researchDetails.researchList[0]?.res_sdg_json !== undefined ? (
                    <>
                      <b className="text-black mb-2 fw-medium">Sustainable Development Goals (SDGs):</b>
                      <Row className="row-cols-md-4 g-3 projectslist w-100">
                      {
                      JSON.parse(researchDetails.researchList[0]?.res_sdg_json).map((sdg, i) => (
                        <Col className="small text-center" key={i}>
                          <Link to={`/research-projects/search-result`} 
                                      state={{ sdg_id: sdg.sdg_id ,
                                               sdg_name : sdg.sdg_name,
                                               facultyId : null,
                                               faculty_name : null,
                                               resStr : null ,
                                               focusAreaId : null ,
                                              focusAreaName : null}}>

                            <div className="rounded-3 border bg-white mb-1 wow fadeInUp">
                              <img src={`${global.variables.strApiUrl}/sdg-icon/${sdg?.sdg_icon}`} alt={sdg?.sdg_name} title={sdg?.sdg_name} className="img-fluid p-0" />
                            </div>
                            <div className="wow fadeInUp">{sdg?.sdg_name}</div>
                          </Link>
                        </Col>
                      ))
                      }
                      </Row>
                    </>
                  ) : null
                } */}
                  </Col>
                  <Col>
                    {
                      resSdgList !== null ? (
                        <>
                          <p className="fw-bold ntext-black mb-2 fw-medium">Sustainable Development Goals (SDGs):</p>
                          <Row className="row-cols-3 row-cols-md-4 row-cols-xxl-4 gx-md-2 gx-2 gy-4 projectslist w-100">
                            {
                              sdgMap[researchDetails.researchList[0]?.res_id]?.map((sdg, i) => (
                                <Col className="small text-center" key={i}>
                                  <Link to={`/research-projects/search-result`}
                                    state={{
                                      sdg_id: sdg.sdg_id,
                                      sdg_name: sdg.sdg_name,
                                      facultyId: null,
                                      faculty_name: null,
                                      resStr: null,
                                      focusAreaId: null,
                                      focusAreaName: null
                                    }}>
                                    {
                                      sdg?.sdg_icon !== null && sdg?.sdg_icon !== "" ?
                                        <div className="rounded-0 mb-1 wow fadeInUp">
                                          <img src={`${global.variables.strApiUrl}/sdg-icon/${sdg?.sdg_icon}`} alt={sdg?.sdg_name} title={sdg?.sdg_name} className="img-fluid p-0 rounded-3" />
                                        </div>
                                        :
                                        null
                                    }
                                    <div className="wow fadeInUp">{sdg?.sdg_name}</div>
                                  </Link>
                                </Col>
                              ))
                            }
                          </Row>
                        </>
                      ) : null
                    }
                  </Col>
                </Row>
              </div>
            </Container>

            {/* Container */}

            {
              (researchDetails.researchList[0]?.res_description !== null && researchDetails.researchList[0]?.res_description !== "") || researchDetails.researchGalleryList.length > 0 || (researchDetails.researchList[0]?.res_pub !== null && researchDetails.researchList[0]?.res_pub !== "") ?
                <Container className="mb-md-5 mb-5">
                  <div className="border rounded-4 px-lg-5 p-4 py-lg-5 h-100">
                    <Row className="g-lg-5 g-4">


                      {
                        researchDetails.researchList[0]?.res_description !== null && researchDetails.researchList[0]?.res_description !== "" ?
                          <Col md={researchDetails.researchList[0]?.res_description !== null && researchDetails.researchList[0]?.res_description !== "" && researchDetails.researchList[0]?.res_pub !== null && researchDetails.researchList[0]?.res_pub !== "" ? 6 : 10}>
                            <div id="AboutEvent">
                              <h5 className="fw-bold mb-3 wow fadeInUp">About Project</h5>
                              <p className="wow fadeInUp" dangerouslySetInnerHTML={{ __html: researchDetails.researchList[0]?.res_description }}></p>
                            </div>
                          </Col>
                          :
                          null
                      }


                      {
                        researchDetails.researchList[0]?.res_pub !== null && researchDetails.researchList[0]?.res_pub !== "" ?
                          <Col md={researchDetails.researchList[0]?.res_pub !== null && researchDetails.researchList[0]?.res_pub !== "" && researchDetails.researchList[0]?.res_description !== null && researchDetails.researchList[0]?.res_description !== "" ? 6 : 10}>
                            <div className="publications">
                              <h5 className="fw-bold mb-0 wow fadeInUp">Publications</h5>
                              <ul className="list-group list-group-flush">
                                <li className="list-group-item bg-transparent px-0 py-3 wow fadeInUp" dangerouslySetInnerHTML={{ __html: researchDetails.researchList[0]?.res_pub }}></li>
                              </ul>
                            </div>
                          </Col>
                          :
                          null
                      }

                      {/* Photo Gallery */}
                      {
                        researchDetails.researchGalleryList.length > 0 ?
                          <Col md={12} lg={12}>
                            <div className="my-md-5">
                              <div className="mb-4">
                                <h3 className="wow fadeInUp">Project Gallery</h3>
                              </div>
                              <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 1280: 3 }}>
                                <Masonry gutter="1.5rem">
                                  {
                                    researchDetails.researchGalleryList?.map((gallery, index) => {
                                      return (
                                        <div>
                                          <Link className="pointer" onClick={(event) => InvokePhotoGallery(event, gallery.res_gallery_res_id, ++index)}>
                                            <img src={`${globalVariables.variables.strApiUrl}/research-gallery-image/${gallery.res_gallery_pic}`} alt={gallery.res_gallery_title} title={gallery.res_gallery_title} className="img-fluid p-0 rounded-3 border bg-white wow fadeInUp" />
                                          </Link>
                                        </div>
                                      )
                                    })
                                  }
                                </Masonry>
                              </ResponsiveMasonry >
                            </div>
                          </Col>
                          :
                          null
                      }


                    </Row>
                  </div>
                </Container >
                :
                null
            }

          </>
          :
          <>
            <Container fluid className="bg-visual-inside-eve-details p-0" >
              <div className="visual-inside-big">
                <Container>
                  <Row className="g-md-0 rounded-4 justify-content-center align-items-center mt-md-5">
                    <Col xs={8} md={6}>
                      <h1 className="fw-light text-white d-inline-block m-0 align-self-center wow fadeInUp">
                        {/* {researchDetails.researchList[0]?.rtype_name} */}
                      </h1>
                    </Col>
                    <Col xs={4} md={6}>
                      <Button onClick={() => navigate(-1)} className="btn btn-primary rounded-pill Faicon px-3 py-1 ms-auto d-flex align-items-center wow fadeInUp">
                        <FaAngleLeft /> Back
                      </Button>
                    </Col>
                  </Row>
                </Container>
              </div>
            </Container>
            <Container className="mb-5 pt-5 news-details">
              <Row >
                <span className="text-center">Loading...</span>
              </Row>
            </Container>
          </>
      }


      {/* Breadcrumb */}
      <Breadcrumb Breadcrumb className="breadcrumb-panel mt-auto">
        <Breadcrumb.Item href={global.variables.strDomainUrl}> Home</Breadcrumb.Item>
        <Breadcrumb.Item href={`${global.variables.strDomainUrl}research-projects/${qs_rtype_pagename}`}>{researchDetails.researchList[0]?.rtype_name}</Breadcrumb.Item>
        {/* <Breadcrumb.Item active>{researchDetails.researchList[0]?.res_title}</Breadcrumb.Item> */}
      </Breadcrumb>


      {/* News Gallery popup */}
      {/* this link will open the news gallery popup which will be hidden because the button from the grid is causing issue */}
      <FsLightbox toggler={toggler}
        sources={[
          "https://i.imgur.com/fsyrScY.jpg",
        ]}
      />

      {/* {/ event Gallery popup /}
        {/ this link will open the event gallery popup which will be hidden because the button from the grid is causing issue /} */}
      <a onClick={(e) => {
        e.preventDefault();
        setResearchGalleryToggler(!research_gallery_toggler);
      }}
        className="d-none"
        id="lnk_trigger_research_gallery_popup_home"></a>
      <FsLightbox toggler={research_gallery_toggler}
        sources={research_gallery?.map(item => {
          return (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center'
            }} key={item.res_gallery_id} className="fsDiv">
              <img className="img-fluid" src={`${globalVariables.variables.strApiUrl}/research-gallery-image/${item.res_gallery_pic}`} alt={item.res_gallery_title} style={{ objectFit: 'contain' }} />
              <p style={{ textAlign: 'center', color: 'white', fontSize: '16px' }}>{item.res_gallery_title}</p>
            </div>
          )
        })}
        key={gallery_key}
        slide={gallerySlide}
      />
    </>
  );
}
